export function isTestEnvironment() {
    return import.meta.env.NODE_ENV === 'test';
}